import { create, tsx } from '@dojo/framework/core/vdom';

import * as css from './Section.m.css';

type SectionType = 'standard' | 'leading' | 'trailing';

interface SectionProperties {
	/**
	 * indicates if it is the last section of the page as different
	 * styling is applied
	 */
	trailing?: boolean;

	/**
	 * adds the shaded background. If `top` or `bottom` is used it
	 * applies the mask, by default the mask is around the section
	 */
	shaded?: boolean;

	/**
	 * The type of section, controls the section padding
	 */
	type?: SectionType;

	/**
	 * Indicate the section should have a background
	 */
	background?: boolean;
}

const factory = create().properties<SectionProperties>();

export const Section = factory(function Section({ children, properties }) {
	const { shaded, background, type = 'standard' } = properties();
	const isShaded = !!shaded;
	return (
		<div classes={[css.root, isShaded && css.shaded, background && css.background]}>
			{isShaded && <div classes={[css.top]} />}
			<div
				classes={[
					css.content,
					isShaded && css.shaded,
					type === 'leading' && css.leading,
					type === 'trailing' && css.trailing
				]}
			>
				{children()}
			</div>
			{isShaded && type !== 'trailing' && <div classes={[css.bottom]} />}
		</div>
	);
});

export default Section;
